import type { LucideIcon } from 'lucide-react';
import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes } from 'react';
import { cx } from '@/lib/cx';
import s from './Input.module.css';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  icon?: LucideIcon;
  size?: 'sm' | 'md';
  mono?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input({ icon: Icon, size = 'md', mono, className, ...rest }, ref) {
  return (
    <span className={cx(s.wrap, s[size], className)}>
      {Icon && <Icon className={s.icon} aria-hidden />}
      <input ref={ref} className={cx(s.input, Icon && s.withIcon, mono && s.mono)} {...rest} />
    </span>
  );
});

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  autoGrow?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea({ className, autoGrow, ...rest }, ref) {
  return <textarea ref={ref} className={cx(s.textarea, autoGrow && s.autoGrow, className)} {...rest} />;
});
